module.exports = __webpack_public_path__ + "img/dislike.e0e96956.svg";